var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeAlter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H15.1591C16.8159 4 18.1591 5.34315 18.1591 7V8.72222C18.1591 10.3791 19.5022 11.7222 21.1591 11.7222M21.1591 11.7222H21.3182M21.1591 11.7222C19.5022 11.7222 18.1591 13.0654 18.1591 14.7222V16.4444C18.1591 18.1013 16.8159 19.4444 15.1591 19.4444H15",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31836 4H8.15927C6.50241 4 5.15927 5.34315 5.15927 7V8.72222C5.15927 10.3791 3.81612 11.7222 2.15927 11.7222M2.15927 11.7222H2.00018M2.15927 11.7222C3.81612 11.7222 5.15927 13.0654 5.15927 14.7222V16.4444C5.15927 18.1013 6.50241 19.4444 8.15927 19.4444H8.31836",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeAlter);
export default __webpack_public_path__ + "static/media/codeAlter.f553e8037e85a5cec61815b98bc68c97.svg";
export { ForwardRef as ReactComponent };